var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1C6.26 1 2 5.26 2 10.5C2 15.57 5.99 19.73 11 19.99V23.59L12.43 22.9C17.56 20.43 21 15.45 21 10.5C21 5.26 16.74 1 11.5 1ZM13 20.3V18H11.5C7.36 18 4 14.64 4 10.5C4 6.36 7.36 3 11.5 3C15.64 3 19 6.36 19 10.5C19 14.23 16.64 18.01 13 20.3ZM10.5 14.5H12.5V16.5H10.5V14.5ZM11.5 4C9.29 4 7.5 5.79 7.5 8H9.5C9.5 6.9 10.4 6 11.5 6C12.6 6 13.5 6.9 13.5 8C13.5 10 10.5 9.75 10.5 13H12.5C12.5 10.75 15.5 10.5 15.5 8C15.5 5.79 13.71 4 11.5 4Z",
    fill: "#003A5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.41f93ba6933769d0beb91f73efd134ba.svg";
export { ForwardRef as ReactComponent };